import { Seo } from "@/components/Seo";

export default function DatenschutzPage() {
  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 py-12">
      <Seo title="Datenschutz | Bohrpunkte" description="Datenschutzhinweise zu Bohrpunkte." />
      <h1 className="text-3xl font-semibold">Datenschutz</h1>
      <div className="mt-6 space-y-4 text-muted-foreground leading-relaxed">
        <p>Dieser Dienst ist datensparsam gestaltet. Die Berechnungen laufen vollständig in deinem Browser. Es gibt keine Nutzerkonten und es werden keine Eingaben an einen Server übertragen oder gespeichert.</p>

        <h2 className="text-lg font-semibold text-foreground">1. Verantwortlicher</h2>
        <p>Adrian Goldner<br/>Keplerstr. 25, 60318 Frankfurt am Main<br/>E-Mail: info@adriangoldner.com</p>

        <h2 className="text-lg font-semibold text-foreground">2. Hosting und Auslieferung</h2>
        <p>Beim Aufruf der Seite werden technisch notwendige Server-Logdaten (z. B. IP-Adresse, Datum und Uhrzeit des Zugriffs, abgerufene Datei, Browsertyp) verarbeitet. Rechtsgrundlage ist Art. 6 Abs. 1 lit. f DSGVO (sicherer Betrieb der Website). Die Auslieferung kann über ein Content Delivery Network der Cloudflare, Inc. (USA) erfolgen. Mit den eingesetzten Dienstleistern bestehen Verträge zur Auftragsverarbeitung nach Art. 28 DSGVO.</p>

        <h2 className="text-lg font-semibold text-foreground">3. Berechnungen</h2>
        <p>Alle Eingaben für die Rechner werden ausschließlich lokal in deinem Browser verarbeitet. Es findet keine Übermittlung dieser Eingaben an uns oder Dritte statt.</p>
        <p>Zusätzlich erfassen wir anonyme Nutzungsereignisse wie den genutzten Rechner, Suchbegriffe und den Ergebnistyp. Diese Daten sind nicht personenbezogen und werden ohne Cookies erhoben.</p>

        {/* TODO: Abschnitt "Werbung (Google AdSense)" ergänzen, bevor AdSense live geht.
            Pflichtangaben: Einsatz von Google AdSense (Google Ireland Ltd.), Werbe-Cookies,
            Rechtsgrundlage Art. 6 Abs. 1 lit. a DSGVO (Einwilligung via Cookie-Banner),
            Drittlandübermittlung USA, Opt-out-Hinweis. Erst aktivieren, wenn AdSense verdrahtet ist. */}

        <h2 className="text-lg font-semibold text-foreground">4. Deine Rechte</h2>
        <p>Du hast das Recht auf Auskunft (Art. 15 DSGVO), Berichtigung (Art. 16), Löschung (Art. 17), Einschränkung der Verarbeitung (Art. 18), Datenübertragbarkeit (Art. 20) sowie Widerspruch (Art. 21 DSGVO). Außerdem steht dir ein Beschwerderecht bei einer Datenschutzaufsichtsbehörde zu.</p>

        <h2 className="text-lg font-semibold text-foreground">Hinweis</h2>
        <p>Dies ist ein Hilfswerkzeug zur Planung. Die Berechnungen ersetzen keine fachliche Prüfung vor Ort.</p>
      </div>
    </div>
  );
}
